module.exports = __webpack_public_path__ + "825bf395c07fdf6be48a938c86d2d6cf.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/social-media/instagram-logo-colour.png
 ** module id = 487
 ** module chunks = 0
 **/